import React from 'react';
import { settleBankingFeeApplies, settleBankingTypeLabel } from '../nodes/SettleNode/SettleConfigModal';

const formatUnits = (value) => Number(value || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 });
const formatPct = (value) => `${Number(value || 0).toFixed(2)}%`;

// Priority-ordered detail of the Settle chain (one row per existing source, then combined
// totals). The annual cards above already sum the existing sources; this shows each one.
// `summary` is the /analysis/source_settlement_summary response, fetched with the rest of the summary.
const SourceSettlementSection = ({ summary }) => {
  if (!summary?.available || !summary.sources?.length) return null;
  const { sources, combined } = summary;

  return (
    <div id="source-settlement" className="summary-section span-2">
      <div className="section-title-row">
        <h3 className="section-title">Existing sources settled in priority order</h3>
      </div>
      <div className="summary-table-wrapper">
        <table className="summary-table">
          <thead>
            <tr>
              <th>Priority</th>
              <th>Source</th>
              <th>Banking</th>
              <th>Demand in</th>
              <th>Same-hour</th>
              <th>Banked (demand)</th>
              <th>Banking used</th>
              <th>Lapsed</th>
              <th>Residual out</th>
              <th>Replaced (of demand in)</th>
            </tr>
          </thead>
          <tbody>
            {sources.map((source) => (
              <tr key={`${source.priority}-${source.source_label}`}>
                <td>{source.priority}</td>
                <td>{source.source_label}</td>
                <td>
                  {settleBankingTypeLabel(source.banking_type)}
                  {settleBankingFeeApplies(source.banking_type) && source.banking_fee != null
                    ? ` (${Math.round(Number(source.banking_fee) * 1e4) / 100}% fee)`
                    : ''}
                </td>
                <td className="numeric-cell">{formatUnits(source.demand_in)}</td>
                <td className="numeric-cell">{formatUnits(source.same_hour)}</td>
                <td className="numeric-cell">{formatUnits(source.banked)}</td>
                <td className="numeric-cell">{formatUnits(source.banking_used)}</td>
                <td className="numeric-cell">{formatUnits(source.surplus_after_bank)}</td>
                <td className="numeric-cell">{formatUnits(source.demand_out)}</td>
                <td className="numeric-cell">{formatPct(source.replacement_pct)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={3}>All existing sources</td>
              <td className="numeric-cell">{formatUnits(combined.original_demand)}</td>
              <td className="numeric-cell">{formatUnits(combined.same_hour)}</td>
              <td className="numeric-cell">{formatUnits(combined.banked)}</td>
              <td className="numeric-cell">{formatUnits(combined.banking_used)}</td>
              <td className="numeric-cell">{formatUnits(combined.surplus_after_bank)}</td>
              <td className="numeric-cell">{formatUnits(combined.residual_to_proposal)}</td>
              <td className="numeric-cell">{formatPct(combined.replacement_pct)}</td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div className="summary-empty">
        Lapsed is the generation left after banking; it does not carry to the next source.
        The residual out of the last source is the demand the proposal is matched against.
      </div>
    </div>
  );
};

export default SourceSettlementSection;
